/**
 * @generated SignedSource<<d02fde1344736220814625b73b11b660>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddMenuItemDialog_menu$data = {
  readonly id: string;
  readonly " $fragmentType": "AddMenuItemDialog_menu";
};
export type AddMenuItemDialog_menu$key = {
  readonly " $data"?: AddMenuItemDialog_menu$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddMenuItemDialog_menu">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddMenuItemDialog_menu",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Menu",
  "abstractKey": null
};

(node as any).hash = "262758321596da6fef97bc53b5ab60c8";

export default node;
